import styled from 'styled-components'

export const Error = styled.div`
  color: ${({ theme }) => theme.color.error};
`
